module.exports = __webpack_public_path__ + "img/11.25adee85.png";